import * as React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import InsertCommentIcon from '@mui/icons-material/InsertComment'
import LastPageIcon from '@mui/icons-material/LastPage'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack } from '@mui/material'
import TableHead from '@mui/material/TableHead'
import '../../App.css'
import '../../css/modal.scss'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { useEffect } from 'react'
import { showListAllAtom } from './jotaiState/receiveStateAtoms'
import { useAtom } from 'jotai'

const CommonTable = (
  {  selelectedData, setSelectedData ,tableData }
) => {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(8)
  const [showListAll]=useAtom(showListAllAtom)

  // All State
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
  })
  const { startIndex, lastIndex, Total, TotalAmount } = state
  const [ListData, setListData] = useState()
  const [TableListData, setTableListData] = useState("DataLoaded")
  // All useEffects
  useEffect(() => {
    if (tableData?.length >= 1) {
      const arry = tableData?.map((val) => ({ ...val, checked: false,DescriptionDet:val.ConsignmentData?.[0].ConsignmentSubType }))  
      setTableListData("DataLoaded")
      setListData(arry)
    } else {
      setListData([])
      setTableListData("Empty")
    }
  }, [tableData])    

  useEffect(() => {
    if (showListAll) {
      setSelectedData(tableData)
      ListData?.map((val) => (val.checked = false))
    } else {
      setSelectedData([])
    }
  }, [tableData, showListAll])
  useEffect(() => {
    const citrus = tableData?.slice(startIndex, lastIndex)
    const total = citrus?.map((item) => item?.Quantity).reduce((partialSum, a) => partialSum + a, 0)
    const totalAmt = citrus?.map((item) => item?.NetAmount).reduce((partialSum, a) => partialSum + a, 0)
    setState({ ...state, Total: total, TotalAmount: totalAmt?.toFixed(2) })
  }, [startIndex, lastIndex, tableData])


  const activeClass = (data) => {
    switch (data.PaymentType) {
      case 'PAID':
        return 'greentwo'
      case 'PAID(Manual)':
        return 'greentwo'
      case 'ON-ACCOUNT':
        return 'graytwo'
      case 'ON-ACCOUNT Manual':
        return 'graytwo'
      case 'TO PAY':
        return 'orangetwo'
      case 'TO PAY Manual':
        return 'orangetwo'
      case 'FOC':
        return 'darkGreentwo'
      case 'COD':
        return 'purpletwo'
      case 'SELF-BOOKING':
        return 'Bluetwo'
      case 'SELF':
        return 'Bluetwo'
      case 'ToPay(DDDV)':
        return 'yellowtwo'
      default:
        break
    }
  }

  const onChange = (e, i) => {
    const { checked, value, id } = e.target
    if (checked) {
      ListData.map((val) => (val.BookingID === Number(id) ? (val.checked = true) : ''))
      const data = ListData?.filter((val) => val.BookingID == Number(e.target.id))
      const selectedObject = [...selelectedData, data[0]]
      setSelectedData(selectedObject)
    } else {
      ListData.map((val) => (val.BookingID === Number(id) ? (val.checked = false) : ''))
      const data = selelectedData.filter((item) => item.BookingID !== Number(id))
      setSelectedData(data)
    }
  }
  function dateFormat(inputDate, format) {
    //parse the input date
    const date = new Date(inputDate)

    //extract the parts of the date
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    //replace the month
    format = format.replace('MM', month.toString().padStart(2, '0'))

    //replace the year
    if (format.indexOf('yyyy') > -1) {
      format = format.replace('yyyy', year.toString())
    } else if (format.indexOf('yy') > -1) {
      format = format.replace('yy', year.toString().substr(2, 2))
    }

    //replace the day
    format = format.replace('dd', day.toString().padStart(2, '0'))

    return format
  }

  

  const InsideRowContent = ({ item, index }) => {
    const [show, setShow] = useState(false)
    //this function for  total
    const handleCalculation = (list, name) => {
      let total = 0
      for (let i in list) {
        total = total + Number(list[i][name])
      }
      return total.toLocaleString('en-IN')
    }

    const handleTotalCalculation = (list) => {
      let frieght = list.ConsignmentData.map((item) => item?.Freight).reduce((partialSum, a) => partialSum + a, 0)
      let total = frieght + list.AllCartage + list.AllHamali + list.OtherCharge + list.Valuation + list.GST
      return total.toLocaleString('en-IN')
    }

    return (
      <>
           <TableBody className="filter-data-row"  key={index} >
        <TableRow>
          <TableCell className="checkbox-ctrl">
            {showListAll ? (
              <input type="checkbox" id={`checkbox_${item.BookingID}`} name="record" checked={true} disabled={true} />
            ) : (
              <input
                type="checkbox"
                id={item.BookingID}
                // value={item}
                onChange={(e) => onChange(e, index)}
                checked={item.checked}
                // name="record"
              />
            )}
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.LRNO}>
              {item.LRNO}              
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.ManualLRNo}>
              {item.ManualLRNo}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.BookingDateTime}>
              {dateFormat(item.BookingDateTime.split(' ')?.[0], 'dd-MM-yyyy')}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.DescriptionDet}>           
              {item.ConsignmentData.length === 1 ? item.DescriptionDet : 'Multi'}
            </span>
          </TableCell>
          <TableCell>
            <span className={activeClass(item)} title={item.PaymentType}>
              {item.PaymentType}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '10px', paddingRight: '30px' }} title={item.Quantity}>
              {item.Quantity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.Sender}>
              {item.Sender}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.RecName}>
              {item.RecName}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.FromCity}>
              {item.FromCity}
            </span>
          </TableCell>
          <TableCell>
            <span style={{ fontSize: '10px' }} title={item.ToCity}>
              {item.ToCity}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '10px', paddingRight: '29px' }} title={item.NetAmount}>
              {Number(item.NetAmount).toLocaleString('en-IN')}
            </span>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <span style={{ fontSize: '10px', paddingRight: '29px' }} title={item.ChallanNo}>
              {/* {item.NetAmount} */}
              {Number(item.ChallanNo).toLocaleString('en-IN')}
            </span>
          </TableCell>
          <TableCell className="iconCell" style={{ textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'end' }}>
            {item.Comments === '' ? (
              ''
            ) : (
              <span title={item.Comments}>
                <InsertCommentIcon id="iconBox" className="icon2" style={{ marginRight: '10px' }} />
              </span>
            )}
            <span
              onClick={() => {
                setShow(!show)
              }}
            >
              {show ? <RemoveCircleIcon id="iconBox" className="icon2 " style={{marginRight:"12px"}}/> : <AddCircleIcon id="iconBox" className="icon2 " style={{marginRight:"12px"}}/>}
            </span>
          </TableCell>
        </TableRow>
        <TableRow >
          <TableCell colSpan={14} style={{ padding: '0' }}>
            <div
              className="tabelAccordionWrapper"
              style={{
                maxHeight: '110px',
                overflowY: 'scroll',
              }}
            >
              <Table className="table1 table-branch sub-table" size="small" aria-label="a dense table">
                <TableBody className="filter-data-row">
                  {show && (
                    <>
                      <TableRow key={index} style={{ background: '#E5D6CF' }}>
                        <TableCell className="checkbox-ctrl" style={{ background: '#E5D6CF' }}></TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }} title={'ConsignmentSubType'}>
                            Consign Type
                          </span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Description</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Unit</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Goods Value</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Weight</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Rate</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Frieght</span>
                        </TableCell>

                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Cartage</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Hamali</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Other</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Valuation</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>GST</span>
                        </TableCell>
                        <TableCell>
                          <span style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>Total</span>
                        </TableCell>
                      </TableRow>

                      {item.ConsignmentData.map((val, i) => {
                        return (
                          <>
                            <TableRow key={i} style={{ background: '#FBEDE7' }}>
                              <TableCell className="checkbox-ctrl" style={{ background: '#FBEDE7' }}></TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.ConsignmentSubType}>
                                  {val.ConsignmentSubType}
                                </span>
                              </TableCell>
                              <TableCell>
                                <span style={{ fontSize: '10px' }} title={val.Description}>
                                  {val.Description}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Quantity}>
                                  {val.Quantity}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.GoodsValue}>
                                  {val.GoodsValue}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.ActualWeight}>
                                  {val.ActualWeight}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Rate}>
                                  {val.Rate}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={val.Freight}>
                                  {/* {val.Freight} */}
                                  {Number(val.Freight).toLocaleString('en-IN')}
                                </span>
                              </TableCell>

                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllCartage}>
                                  {/* {item.AllCartage} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllCartage}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.AllHamali}>
                                  {/* {item.AllHamali} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.AllHamali}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.OtherCharge}>
                                  {item.ConsignmentData.length > 1 ? 0 : item.OtherCharge}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {/* {item.Valuation} */}
                                  {item.ConsignmentData.length > 1 ? 0 : item.Valuation}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={Number(item.GST).toLocaleString('en-IN')}>
                                  {item.ConsignmentData.length > 1 ? 0 : Number(item.GST).toLocaleString('en-IN')}
                                </span>
                              </TableCell>
                              <TableCell style={{ textAlign: 'right' }}>
                                <span style={{ fontSize: '10px' }} title={item.Valuation}>
                                  {item.ConsignmentData.length > 1 ? 0 : handleTotalCalculation(item)} 
                                </span>
                              </TableCell>
                            </TableRow>
                          </>
                        )
                      })}
                      {item.ConsignmentData.length > 1 ? (
                        <TableRow style={{ background: '#e9d5cf' }}>
                          <TableCell className="checkbox-ctrl" style={{ background: '#e9d5cf' }}></TableCell>
                          <TableCell>
                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>Grand Total</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}></span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Quantity')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'GoodsValue')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'ActualWeight')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>{handleCalculation(item.ConsignmentData, 'Rate')}</span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleCalculation(item.ConsignmentData, 'Freight')}
                            </span>
                          </TableCell>

                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllCartage}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.AllHamali}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.OtherCharge}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>{item.Valuation}</span>
                          </TableCell>
                          <TableCell>
                            <span style={{ fontSize: '10px', fontWeight: 'bold', textAlign: 'right' }}>
                              {Number(item.GST).toLocaleString('en-IN')}
                            </span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'right' }}>
                            <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                              {handleTotalCalculation(item)}
                            </span>
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </div>
          </TableCell>
        </TableRow>
        </TableBody>
      </>
    )
  }

  //All Functionality of pagination  start
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  function TablePaginationActions(props) {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
      setState({ ...state, startIndex: 0, lastIndex: 8 })
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
      setState({ ...state, startIndex: startIndex - 8, lastIndex: startIndex })
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
      if (tableData.length >= lastIndex + 8) {
        setState({ ...state, startIndex: lastIndex, lastIndex: lastIndex + 8 })
      } else {
        setState({ ...state, startIndex: lastIndex, lastIndex: tableData?.length + 1 })
      }
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      const div=tableData?.length % 8
      if(div==0){
      const index = tableData?.length - 8
      setState({ ...state, startIndex: index, lastIndex: tableData?.length + 1 })
      } else {
        const index = tableData?.length - (tableData?.length % 8)
        setState({ ...state, startIndex: index, lastIndex: tableData?.length + 1 })
      }
    }

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page" style={{padding:"0px",margin:"0px"}}>
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} style={{padding:"0px",margin:"0px"}} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}  style={{padding:"0px",margin:"0px"}} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} style={{padding:"0px",margin:"0px"}} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }
  //All Functionality of pagination end

  let repeatdata = [
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
    { name: 'contains' },
  ]
 
  return (
    <>
    <Stack sx={{ maxHeight: 360, minHeight: 360, minWidth: 650, margin: 2, marginRight: 3, marginLeft: 3 }}>
       
      <TableContainer className="lr-popup-table lrModel " component={Paper}>
        <Table style={{}} className="table1 table-branch receiveTable" size="small" aria-label="a dense table" id="showlisttable">
          <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
            <TableRow style={{ background: '#d9edff' }}>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px 10px 25px', fontWeight: 'bold' }}>Select</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>LR/Way Bill No.</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Manual LR</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Booking Date</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Consign Type</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Payment Type</TableCell>
              <TableCell className="receiveTableTd">Units</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Sender</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Receiver</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Source</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold' }}>Destination</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign:'right',paddingRight:"32px" }}>Amount</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign:'right',paddingRight:"32px" }}>Challan</TableCell>
              <TableCell style={{ fontSize: '13px', padding: '10px 0px', fontWeight: 'bold', textAlign:'right',paddingRight:"30px"}}>Activity</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="checkbox-ctrl">             
              </TableCell>
              {repeatdata.map((item, i) => (
                
                  <TableCell key={i}>
                    <div className={`filter-input ${i==11?"last-filter":null}`}>
                      <span className="field">{item.name}</span>
                      <FilterAltIcon />
                    </div>
                  </TableCell>
    
              ))}
              {/* <TableCell></TableCell> */}
            </TableRow>
          </TableHead>
          {TableListData === "Empty" ? (
            <>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={13}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                        color: 'red',
                        fontSize: '14px',
                      }}
                    >
                      <span>No results found. Please refine your search parameters and search again.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </>
          ) : TableListData === "DataLoaded" ?  (
            <>
              {(rowsPerPage > 0 ? ListData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : ListData)?.map((item, index) => (
                <InsideRowContent item={item} index={index}  />
              ))}
             </>
          ):""}
          <TableFooter>
            <TableRow>
            <TableCell colSpan={5} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
            <TableCell style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right', paddingRight: '7px' }}>Total</TableCell>
            <TableCell style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right', paddingRight: '52px' }}>
              {Total===undefined?"":Number(Total).toLocaleString('en-IN')}
            </TableCell>
            <TableCell colSpan={3} style={{ fontSize: '13px', fontWeight: 'bold' }}></TableCell>
            <TableCell colSpan={2} style={{ fontSize: '9px', fontWeight: 'bold', textAlign: 'right' ,paddingRight:"30px"}} >
              {TotalAmount===undefined?"":Number(TotalAmount).toLocaleString('en-IN')}
            </TableCell>
            <TableCell colSpan={2}></TableCell>
            </TableRow>
            <TableRow >

            <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            // colSpan={3}
            count={tableData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            className='test123'
            SelectProps={{
              inputProps: {
                'aria-label': 'rows per page',
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Stack>
      </>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
}
export default connect(mapStateToProps, mapDispatchToProps)(CommonTable)
